import { MDXProvider } from '@mdx-js/react';

import { Link } from '@/core/i18n/navigation';
import { getLocale } from '@/paraglide/runtime.js';
import English from '@/content/control-resonant/home-reading.en.mdx';
import Chinese from '@/content/control-resonant/home-reading.zh.mdx';

export function HomeReading() {
  const Content = getLocale() === 'zh' ? Chinese : English;
  return (
    <section className="crt-section crt-container crt-prose crt-home-reading">
      <MDXProvider
        components={{
          a: ({ href = '', ...props }: React.ComponentProps<'a'>) => (
            <Link href={href} {...props} />
          ),
        }}
      >
        <Content />
      </MDXProvider>
    </section>
  );
}
